import { ProgressBarAutoComponent } from './progress-bar-auto.component';

export default angular
  .module('sfMobile.components.progress-bar-auto', [
    'sfMobile.components.progressBar',
  ])
  .component('sfProgressBarAuto', ProgressBarAutoComponent).name;
